import comp from "./EULAModal";
export default comp;
